<section class="secondary-drawer-container">
    <button class="drawer-close-btn mat-elevation-z0" (click)="dismiss()" mat-mini-fab aria-label="Close">
        <mat-icon>close</mat-icon>
    </button>
    <h5 class="drawer-title">Edit asset</h5>
</section>

<section class="custom-scroller add-asset-form">
    <form name="form" #f="ngForm">
        <div class="row">
            <mat-form-field appearance="outline" class="asset-name">
                <mat-label>Asset Name</mat-label>
                <input type="text" matInput name="assetName" [(ngModel)]="asset.name" #assetName="ngModel" required
                    pattern=".*\S.*" />
                <mat-error *ngIf="assetName.errors && (assetName.dirty || assetName.touched)">Asset name
                    is required</mat-error>
            </mat-form-field>
        </div>

        <div class="row">
            <mat-form-field appearance="outline">
                <mat-label>Manufacturer</mat-label>
                <input type="text" matInput name="assetMake" [(ngModel)]="asset.make" />
            </mat-form-field>
        </div>

        <div class="row">
            <div class="col-6">
                <mat-form-field appearance="outline" class="shortCol">
                    <mat-label>Model</mat-label>
                    <input type="text" matInput name="assetModel" [(ngModel)]="asset.model" />
                </mat-form-field>
            </div>

            <div class="col-6">
                <mat-form-field appearance="outline" class="shortCol">
                    <mat-label>Barcode</mat-label>
                    <input type="text" matInput name="assetBarcode" [(ngModel)]="asset.barcode" />
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <mat-form-field appearance="outline">
                <mat-label>Date of Purchase</mat-label>
                <input matInput [matDatepicker]="picker_date_of_purchase" placeholder="DD/MM/YY" name="dateOfPurchase"
                    [(ngModel)]="asset.dateOfPurchase">
                <mat-datepicker-toggle matSuffix [for]="picker_date_of_purchase">
                </mat-datepicker-toggle>
                <mat-datepicker #picker_date_of_purchase></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="row">
            <mat-form-field appearance="outline">
                <mat-label>Useful Life Period (Years)</mat-label>
                <input type="number" min="0" matInput name="assetUsefulLife" [(ngModel)]="asset.usefulLife" />
            </mat-form-field>
        </div>

        <mat-form-field appearance="outline">
            <mat-label>Cost ($)</mat-label>
            <input
              type="text"
              matInput
              name="cost"
              [value]="formatCost(asset.cost)"
              (blur)="onCostBlur($event)"
              appTwoDigitDecimaNumber
            />
        </mat-form-field> 

        <div class="row">
            <mat-form-field appearance="outline">
                <mat-label>Maintenance cycle</mat-label>
                <mat-select [(value)]="asset.maintenanceCycle">
                    <mat-option *ngFor="let option of assetMaintenanceCycleTypeOptions" [value]="option.key">
                        {{option.value}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="row">
            <mat-form-field appearance="outline">
                <mat-label>Description</mat-label>
                <textarea matInput name="assetDescription" [(ngModel)]="asset.description" class="edit-description"
                    autosize></textarea>
            </mat-form-field>
        </div>

        <div class="row">
            <mat-form-field appearance="outline">
                <mat-label>Note</mat-label>
                <textarea matInput name="assetNote" [(ngModel)]="asset.note" class="edit-description"
                    autosize></textarea>
            </mat-form-field>
        </div>

        <div class="row">
            <app-file-upload (UploadedAttachments)="addUploadedAttachments($event)" [showImageEditor]="true"
                [config]="config">
            </app-file-upload>
        </div>

        <div class="inner-drawer-actions">
            <button class="common-button light-gray mat-elevation-z0 ms-2" mat-button mat-raised-button
                [disabled]="isSaving" (click)="dismiss()">Cancel</button>
            <button type="submit" class="common-button black mat-elevation-z0 ms-2" mat-button mat-raised-button
                [disabled]="f.invalid || isSaving" [class.spinner]="isSaving" (click)="save()">Save</button>
        </div>
    </form>
</section>